import { Button } from '@kizen/kds/Button';
import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type SetupFormProps = {
  onCancel: () => void;
};

export const SetupForm = (props: SetupFormProps) => {
  const { onCancel } = props;
  const { t } = useTranslation();

  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState<string>();

  const handleSubmit = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();
      setErrorMessage(undefined);

      // Stripe js hasn't been loaded yet
      if (!stripe || !elements) {
        return null;
      }

      const { error } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: `${window.location.href}?success=true`,
        },
      });

      if (error) {
        setErrorMessage(error.message);
      } else {
        // noop, redirect will happen automatically
      }
    },
    [stripe, elements]
  );

  return (
    <form onSubmit={handleSubmit} className="kds pb-[10px]">
      {errorMessage ? (
        <>
          <Typography color="feedback-toast-error">{errorMessage}</Typography>
          <Spacer size={20} />
        </>
      ) : null}
      <div className="min-h-[173px]">
        <PaymentElement />
      </div>
      <Spacer size={20} />
      <div className="flex flex-col items-end">
        <div className="flex gap-10">
          <Button
            variant="text"
            color="warning"
            type="button"
            onClick={onCancel}
          >
            {t('Cancel')}
          </Button>
          <Button type="submit">{t('Submit Details')}</Button>
        </div>
      </div>
    </form>
  );
};
